module.exports = __webpack_public_path__ + "img/paybybank.78a0870c.svg";